import treeimg from "../../../assets/images/Diagram3.png";

function ASMFCEPPage() {
  return (
    <>
      <div className="flex items-center gap-2 mb-12">
        <span className="w-4 h-4 rounded-full bg-sky-300 flex-shrink-0"></span>
        <h3 className="text-lg font-semibold text-[#05326D]">
          ASMF & CEP Submission Services
        </h3>
      </div>
      <img src={treeimg} alt="USDMF" className="w-120 h-auto mb-12 rounded-md" />

      <h4 className="text-md font-bold text-[#05326D] mb-4">
        Strategic Regulatory Solutions for European Market Access
      </h4>
      <p className="text-[#05326D] mb-8">At FDAC, we deliver comprehensive and compliant solutions for Active Substance Master File (ASMF) and
        Certificate of Suitability (CEP/COS) submissions across Europe. Our team guides clients through every stage of the
        process—from dossier preparation to electronic publishing and submission—ensuring regulatory alignment and
        timely review.  </p>

      <p className="text-[#05326D] mb-8">Whether you’re filing with EDQM or individual European health authorities, FDAC provides tailored support to
        meet the highest standards of quality and confidentiality.</p>

      <hr className="border-t border-gray-300 mb-8" />

      <div className="flex items-center gap-2 mb-2">
        <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
        <span className="text-[16px] font-bold text-[#05326D]">
          ASMF & CEP: Overview
        </span>
      </div>
      <div className=" space-y-1">
        <p className="text-[15px] text-[#05326D] mb-4">
          <span className="text-[16px] font-bold">ASMF: </span>
          Submitted to European regulatory agencies, ASMFs provide confidential information on the manufacturing
          and control of Active Pharmaceutical Ingredients (APIs). They are reviewed when referenced in a Marketing
          Authorization Application (MAA) but are not formally approved or rejected.
        </p>
        <p className="text-[15px] text-[#05326D] mb-4">
          <span className="text-[16px] font-bold">CEP :</span> Submitted to EDQM, the CEP dossier undergoes a formal review and approval process. Once granted, it
          certifies that the API complies with European Pharmacopoeia standards and can be referenced in MAA
          submissions.
        </p>
      </div>
      <div className="flex items-center gap-2 mb-4 mt-4">
        <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
        <span className="text-[16px] font-bold text-[#05326D]">
          ASMF Structure
        </span>
      </div>

      <div className=" space-y-1">
        <p className="text-[15px] text-[#05326D] mt-2">
          <span className="font-semibold">Applicant’s Part (AP): </span>
          Shared with the applicant for inclusion in the MAA dossier
        </p>
        <p className="text-[15px] text-[#05326D] mt-2">
          <span className="font-semibold">Restricted Part (RP):
          </span> Submitted confidentially to regulatory authorities for evaluation
        </p>
        <p className="text-[#05326D] mt-2">
          Both parts contain CMC (Chemistry, Manufacturing, and Controls) information and are submitted via procedures
          such as National, MRP, RUP, and DCP.</p>
      </div>

      <div className="flex items-center gap-2 mb-4 mt-4">
        <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
        <span className="text-[16px] font-bold text-[#05326D]">
          FDAC’s ASMF & CEP Services
        </span>
      </div>
      <p className="text-md font-semibold text-[#05326D] mb-4">Writing & Documentation </p>

      <p className="ml-2 mt-2 text-[#05326D]">- Due Diligence & Technical Audits</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Conversion from Paper/CTD to eCTD</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Authoring of Modules 1, 2, and 3 for ASMF (AP & RP) and CEP</p>
      <p className="ml-2 mt-2 text-[#05326D]">- CEP Dossier Preparation for APIs</p>
      <p className="ml-2 mt-2 text-[#05326D]">- QOS in QbR Format</p>

      <div className="flex items-center gap-2 mb-4 mt-6">
        <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
        <span className="text-[16px] font-bold text-[#05326D]">
          eCTD Publishing & Submission
        </span>
      </div>

      <p className="ml-2 mt-2 text-[#05326D]">- eCTD Compilation, QC Review, Technical Validation & Hosting</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Baseline Conversion from Paper/CTD/NeeS</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Importing & Cloning of Existing Applications</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Publishing & Submission via CESP (for ASMF) and EDQM Portal (for CEP)</p>
      <p className="ml-2 mt-2 text-[#05326D]">- PDF Optimization: OCR, Font Embedding, Bookmarking, Hyperlinking</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Query Response Support during MAA Review</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Assistance with Validation Issues & Additional Information Requests</p>


      <div className="flex items-center gap-2 mb-2 mt-4">
        <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
        <span className="text-[16px] font-bold text-[#05326D]">
          Lifecycle Management
        </span>
      </div>

      <p className="ml-2 mt-2 text-[#05326D]">- ASMF Revisions, Updates & Full Rewrites</p>
      <p className="ml-2 mt-2 text-[#05326D]">- CEP Amendments & Renewals</p>
      <p className="ml-2 mt-2 text-[#05326D]">- Ongoing Regulatory Support for Safe and Compliant Approvals</p>

      <hr className="border-t border-gray-300 mb-8 mt-8" />

      <div className="flex items-center gap-2 mb-2 mt-4">
        <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
        <span className="text-[16px] font-bold text-[#05326D]">
          Why FDAC?
        </span>
      </div>
      
      <p className="ml-2 mt-2 text-[#05326D]">- Proven expertise in European regulatory frameworks</p>
      <p className="ml-2 mt-2 text-[#05326D]">- End-to-end project management—from strategy to submission </p>
      <p className="ml-2 mt-2 text-[#05326D]">- Customized solutions aligned with international guidance and standards </p>
      <p className="ml-2 mt-2 text-[#05326D]">- Seamless integration with global regulatory pathways</p>
      <p className="ml-2 mt-4 text-[#05326D]">

        Whether you’re preparing an ASMF for multiple EU markets or submitting a CEP to EDQM, FDAC ensures your
        documentation is accurate, confidential, and strategically positioned for success.</p>
    </>

  );
}

export default ASMFCEPPage;
